<template>
	<v-dialog
		v-model="showDialog"
		max-width="1200px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">データ選択</v-app-bar-title>
			</v-app-bar>
			<v-card-text class="pa-2 table-container">
				<v-data-table
					locale="ja-JP"
					:headers="headers"
					:items="items"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr @click="selectItem(item)" class="clickable">
							<td v-for="(column, i) in columns" :key="i">
								<p
									v-if="column.data_type == 'text'"
									class="pre-wrap"
									v-text="tdValue(column, item)"
								/>
								<template v-else>
									{{ tdValue(column, item) }}
								</template>
							</td>
						</tr></template
					>
				</v-data-table>
				<PaginationModule :pagination="pagination" @get-page="getPage($event)" />
			</v-card-text>
			<v-card-actions>
				<v-row class="ma-0 pa-0" justify="end">
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" text @click="showDialog = false"> 閉じる </v-btn>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import moment from "moment/min/moment.min.js"
import axios from "axios"
import rules from "../../../helper/rules"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import PaginationModule from "../../shared/PaginationModule.vue"

export default {
	components: {
		PaginationModule,
	},
	props: {
		id: {
			type: null,
		},
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			items: [],
			columns: [],
			headers: [],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			rules: rules,
		}
	},
	methods: {
		getItems(i) {
			const headers = authenticate.setHeader()
			const url = `/erp/v1//printed_matters/${this.id}/models`
			const params = {
				page: i,
			}
			axios
				.get(url, {
					headers,
					params,
				})
				.then((res) => {
					this.items = res.data.items
					this.columns = res.data.columns
					this.pagination = res.data.pagination
					this.headers = res.data.columns.map((column) => {
						let width = column.width ? column.width : 200
						return { text: column.name, value: column.id, width }
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(i) {
			const element = document.getElementsByClassName("v-dialog v-dialog--active")[0]
			element.scrollTo({
				top: 0,
				behavior: "smooth",
			})
			this.getItems(i)
		},
		tdValue(column, item) {
			const value_array = column.id.split(".")
			let value = item
			value_array.forEach((key) => {
				value = value[key]
				if (value == null || value == undefined) return null
			})
			switch (column.data_type) {
				case "date":
					return moment(value).format("YYYY/MM/DD")
				case "datetime":
					return moment(value).format("YYYY/MM/DD HH:mm:ss")
				case "time":
					return moment(value).format("HH:mm")
				default:
					return value
			}
		},
		selectItem(item) {
			this.$router.push({
				name: "printed_matter_show",
				params: { id: this.id },
				query: { model_id: item.id },
			})
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
		// printedMatter: {
		// 	get() {
		// 		return this.printed_matter
		// 	},
		// 	set(newVal) {
		// 		return this.$emit("update:printed_matter", newVal)
		// 	},
		// },
	},
	watch: {
		id(newVal, oldVal) {
			if (newVal == oldVal) return
			this.getItems(1)
		},
		deep: true,
	},
}
</script>

